export class AgentErrorEvent {
  constructor(json) {
    this.type = json.Type;
    this.command = json.Command;
    this.contactId = json.ContactId;
    this.errorLevel = json.ErrorLevel;
    this.resultCode = json.ResultCode;
    this.target = json.Target;
  }

  get description() {
    return `${this.type} -> ${this.command} ${this.resultCode}`;
  }
}
